// Grupos de perturbação e classificação de tipo de cliente partilhados por 2+ dashboards
// (clinic-service-team-kpis, client-conversion-rate). Ver README do framework, secção "Métricas
// partilhadas". Extraído de teamKpisOutcomes.ts (que re-exporta para manter os importadores).

// Grupos do Zoho "grouped_disorder_name" (4 grupos), chaveados pelo ID do disorder (a BD tem erros
// de escrita nos nomes). Sem diagnóstico e disorders novos ainda não mapeados contam em "Outros".
export type CoarseDisorderGroupKey = "phda" | "autismo" | "ansiedade" | "outros";

export const COARSE_DISORDER_GROUPS: Array<{ key: CoarseDisorderGroupKey; label: string }> = [
    { key: "phda", label: "PHDA" },
    { key: "autismo", label: "Autismo" },
    { key: "ansiedade", label: "Ansiedade" },
    { key: "outros", label: "Outros" },
];

const DISORDER_ID_TO_COARSE_GROUP: Record<number, CoarseDisorderGroupKey> = {
    1: "phda", // ADD
    2: "phda", // ADHD
    14: "phda", // P. Oposição e Desafio
    20: "phda", // P. Aprendizagem
    22: "phda", // P. Comportamento
    35: "phda", // SP. Problemas comportamentais
    36: "phda", // SP. Problemas emocionais
    8: "autismo", // P. Integração sensorial
    10: "autismo", // PEA não verbal
    27: "autismo", // PEA Ligeiro (Asperger)
    28: "autismo", // PEA verbal
    19: "ansiedade", // P. Ansiedade
};

export const coarseDisorderGroupOf = (diagnoseMainId: number | string | null | undefined) => {
    if (diagnoseMainId === null || diagnoseMainId === undefined) return "outros" as CoarseDisorderGroupKey;
    const groupKey = DISORDER_ID_TO_COARSE_GROUP[Number(diagnoseMainId)] ?? "outros";
    return groupKey;
};

export const coarseDisorderGroupLabel = (groupKey: CoarseDisorderGroupKey) => {
    const group = COARSE_DISORDER_GROUPS.find((candidate) => candidate.key === groupKey);
    const label = group ? group.label : groupKey;
    return label;
};

export const disorderDrillLabelOf = (diagnoseMain: { id: number | string; name?: string | null } | null | undefined) => {
    const groupLabel = coarseDisorderGroupLabel(coarseDisorderGroupOf(diagnoseMain?.id));
    const disorderName = diagnoseMain?.name || "Sem diagnóstico";
    const label = `${disorderName} (${groupLabel})`;
    return label;
};

// Convenção da clínica: >18 adulto; ≤18 e sem idade = criança. A função aceita QUALQUER idade — o
// team-kpis passa age_when_started; o client-conversion-rate passa a idade calculada na data da consulta.
export type ClientTypeKey = "adults" | "children";

export const CLIENT_TYPE_LABELS: Record<ClientTypeKey, string> = { adults: "Adulto", children: "Criança" };

export const clientTypeOfAge = (age: number | null | undefined) => {
    const clientType: ClientTypeKey = age !== null && age !== undefined && age > 18 ? "adults" : "children";
    return clientType;
};
